import styled from '@emotion/styled';
import { Button } from '@pairy/pds-react';

export const UpgradeButtonWrapper = styled(Button)`
  padding: 16px;
  border-radius: 9999px;
`;
